import { ReactNode } from 'react';

import { css } from '@compiled/react';

const containerStyle = css({
	display: 'flex',
	flexFlow: 'column',
	alignItems: 'center',
	alignSelf: 'center',
});

export const PostOrderProvisioningContainer = ({ children }: { readonly children?: ReactNode }) => {
	return <div css={containerStyle}>{children}</div>;
};

export default PostOrderProvisioningContainer;
